import { httpManager as http } from '@/plugins/HttpManager';
import { formatToFormUrlencoded, getCookie, getFromClient, setToClient, clearClient } from '@/common/js/utils';
import { config, setConfig } from 'CONFIG';
import store from '@/store';
import bcsdk from 'Bcsdk';
import { unfoldError } from '../common/js/notice';
import { AxiosError } from 'axios';
import { GetTokenOutput } from '@reolink-web/app-sdk';
import { createEmailMFACode } from '@/api/mfa';

const prefix = process.env.NODE_OEM ? `${process.env.NODE_OEM}_` : '';

export const ACCESS_TOKEN_KEY = `my_${prefix}cloud_access_token`;
export const ACCESS_TOKEN_EXPIRES_KEY = `my_${prefix}cloud_token_expires`;
const CURRENT_ACCOUNT = `my_${prefix}cloud_current_account`;
const ISSUED_AT = `my_${prefix}issued_at`;
const REO_SESS_AUTH_CODE = bcsdk.REO_SESS_AUTH_CODE;
const REO_ONLINE_SIGN = bcsdk.REO_ONLINE_SIGN;
class User {

    private accessToken: string;

    private tokenExpires: number;

    private currentAccount;

    private issuedAt;
    
    private mfaId: string = '';
    
    private get email(): string {

        return store.state.user.user.email.address;
    
    }

    public appIsLogin = false;

    public constructor () {

        this.accessToken = getFromClient( ACCESS_TOKEN_KEY );
        this.tokenExpires = parseInt( getFromClient( ACCESS_TOKEN_EXPIRES_KEY ));

    }

    public async goToAccountCenter ( requiresAuth: boolean, targetUrl?: string, search?: string ): Promise<void> {

        const accountCenterLoginUrl = config.accountCenterLoginUrl;
        const currentUrl = window.location.href;
        console.log( 'goToAccountCenter' );
        try {

            await bcsdk.clearLoginCookie();
        
        } catch ( e ) {
            
            console.error( 'clear login cookie error', e );
            unfoldError( 'errors.server_error', 10000 );
            return;
        
        }
        if ( bcsdk.destorySessionCode() && requiresAuth ) {

            console.error( 'go to login' );
            if ( targetUrl ) {

                window.location.href = `${accountCenterLoginUrl}?redirect=${encodeURIComponent( window.location.origin + targetUrl + ( search ?? window.location.search ))}`;

            } else {

                window.location.href = `${accountCenterLoginUrl}?redirect=${encodeURIComponent( currentUrl )}`;

            }

        }

    }

    public tokenValid (): boolean {

        const valid = this.accessToken && this.tokenExpires && ( new Date().getTime() < this.tokenExpires - 60000 );
        console.log( 'token valid -> ' + valid );
        return Boolean( valid );

    }

    public async getToken (): Promise<void> {

        try {

            const { accessToken, tokenExpires } = await this.getTokenFromServer();
            const expires = tokenExpires * 1000 + new Date().getTime();
            this.accessToken = accessToken;
            this.tokenExpires = expires;
            const currentDate = new Date( expires );
            setToClient( ACCESS_TOKEN_KEY, accessToken, currentDate.getTime());
            setToClient( ACCESS_TOKEN_EXPIRES_KEY, expires.toString(), currentDate.getTime());
            console.log( 'set token suc' );

        } catch ( err ) {

            console.error( `Failed to get token. ${err as any}` );
            this.goToAccountCenter( true ).catch( console.error );

        }

    }

    public setTokenFromApp ( tokenData: GetTokenOutput ): void {

        const { token, clientId, expiresIn = ( new Date()).getTime() + 1500 * 100 } = tokenData ;

        this.setValue( 'accessToken', token );
        setConfig( 'clientId', clientId );

        this.setValue( 'tokenExpires', expiresIn );
        const currentDate = new Date( expiresIn );

        setToClient( ACCESS_TOKEN_KEY, token, currentDate.getTime());
        setToClient( ACCESS_TOKEN_EXPIRES_KEY, expiresIn.toString(), currentDate.getTime());
        if ( token !== '' ) {

            this.appIsLogin = true;

        }

        this.refreshHeader();

    }

    public getTokenFromServer (): Promise<{

        accessToken: string;
        tokenExpires: number;

    }> {

        return new Promise(( resolve, reject ) => {

            const body = {

                client_id: config.clientId,
                grant_type: 'session_implicit',
                code: getCookie( REO_SESS_AUTH_CODE )

            };

            http.httpRequest({

                method: `POST`,
                url: `/oauth2/token/`,
                data: formatToFormUrlencoded( body ),
                config: {

                    headers: {

                        'content-type': 'application/x-www-form-urlencoded'

                    },
                    withCredentials: true,
                    baseURL: config.baseUrl + 'v1.0/'

                }

            }).then( res => {

                const data = res.data;
                const { access_token: accessToken, expires_in: tokenExpires } = data;
                console.log( 'get token from server' );
                resolve({

                    accessToken,
                    tokenExpires

                });

            }).catch( err => {

                reject( err );

            });

        });

    }

    public accuontCenterIsLogined (): boolean {

        try {

            return getCookie( REO_ONLINE_SIGN ) !== null;

        } catch ( err ) {

            return false;

        }

    }

    public async login ( requiresAuth: boolean, targetUrl?: string ): Promise<boolean> {

        if ( !this.accuontCenterIsLogined()) {

            console.log( 'account not logined' );
            store.commit( 'LOGIN', { id: 0 });
            await this.goToAccountCenter( requiresAuth, targetUrl, '' );
            return false;

        }
        bcsdk.reflashToken( config.clientId );
        console.log( 'account logined' );
        try {

            await this.getSession();

        } catch ( err ) {

            if ( requiresAuth ) {

                store.commit( 'LOGIN_ERROR', true );

            } else {

                await bcsdk.clearLoginCookie();
                this.clearToken();
                store.commit( 'LOGOUT' );

            }
            return false;

        }
        if ( this.tokenValid() && this.sessionValid()) {

            console.log( 'login with last session and token' );
            this.refreshHeader();
            return true;

        }
        console.log( 'session or token is not valid' );
        try {

            await this.getToken();
            this.refreshHeader();
            this.refreshSession();
            console.log( 'logined' );
            return true;

        } catch ( err ) {

            if ( requiresAuth ) {

                const symbol = ( err as AxiosError ).response?.data.error.symbol;
                if ( symbol === 'account_forbidden' ) {

                    throw err;

                } else {

                    store.commit( 'LOGIN_ERROR', true );

                }

            } else {

                await bcsdk.clearLoginCookie();
                this.clearToken();
                store.commit( 'LOGOUT' );

            }
            console.error( err );
            return false;

        }

    }

    public async getTOTP (): Promise<any> {

        try {

            const data = await http.get( '/auth/mfa/totp' );
            return data.data;

        } catch ( err ) {

            console.log( err );

        }

    }

    public async getIsDeletingAccount () {

        try {

            const data = await http.get( '/user/abandonment' );
            return data.data;

        } catch ( err ) {

            console.log( err );
            unfoldError( 'errors.server_error', 10000 );

        }

    }

    public async cancelDeleteAccount () {

        try {

            await http.delete( '/user/abandonment' );

        } catch ( err ) {

            console.log( err );
            unfoldError( 'errors.server_error', 10000 );

        }

    }

    public refreshSession () {

        console.log( 'refresh session' );
        const expires = 86400 * 1000 + new Date().getTime();
        const currentDate = new Date( expires );
        setToClient( CURRENT_ACCOUNT, this.currentAccount, currentDate.getTime());
        setToClient( ISSUED_AT, this.issuedAt, currentDate.getTime());

    }

    public refreshHeader () {

        console.log( 'refresh Authorization header' );
        http.setHeader( `Authorization`, `Bearer ${this.accessToken}` );

    }

    public async getUserInfo (): Promise<void> {

        console.log( 'get info' );

        try {

            const currentUser = store.getters.userInfo.user;
            const profilePromise = http.get( `/users/@me/profile/`, {
                baseURL: config.baseUrl + 'v1.0/'
            });

            const promises: Array<Promise<any>> = [profilePromise];

            if ( currentUser?.id ) {

                promises.push( Promise.resolve({ enabled: currentUser.totp }));

            } else {

                promises.push( this.getTOTP());

            }

            if ( currentUser?.id && currentUser.status ) {

                console.log( 'Using cached Deletion status' );
                promises.push( Promise.resolve({ status: currentUser.status, waitTime: currentUser.waitTime, scheduledAt: currentUser.scheduledAt }));

            } else {

                console.log( 'Fetching fresh Deletion status' );
                promises.push( this.getIsDeletingAccount());

            }

            const [profileRes, totpResult, deletionResult] = await Promise.all( promises );

            const { status = '', waitTime = 0, scheduledAt = 0 } = deletionResult || {};
            const { enabled: totpEnabled = false } = totpResult || {};

            const user = {
                ...profileRes.data,
                totp: totpEnabled,
                status,
                waitTime,
                scheduledAt
            };

            store.commit( 'LOGIN', { ...user });
            console.log( 'get info suc' );

        } catch ( err ) {

            // Handle potential errors from Promise.all or individual fetches
            const symbol = ( err as AxiosError )?.response?.data?.error?.symbol;
            if ( symbol === 'account_forbidden' ) {

                throw err;

            } else {

                store.commit( 'LOGIN_ERROR', true );
                console.log( 'get info err' );

            }

        }

    }

    public getSession () {

        return new Promise(( resolve, reject ) => {

            const sessionCode = getCookie( REO_SESS_AUTH_CODE )!;
            http.httpRequest({

                method: `GET`,
                url: `/oauth2/session/details/`,
                config: {

                    withCredentials: true,
                    baseURL: config.baseUrl + 'v1.0/',
                    headers: {
                        'Authorization': `refresh_token ${sessionCode}`
                    }
                }

            }).then( res => {

                const { account, issuedAt } = res.data;
                this.currentAccount = account;
                this.issuedAt = issuedAt;
                resolve( 0 );

            }).catch( err => {

                console.log( `session error ======> ${err}` );
                // this.goToAccountCenter();
                reject( err );

            });

        });

    }

    public sessionValid () {

        const lastAccount = parseInt( getFromClient( CURRENT_ACCOUNT ));
        const lastIssued = parseInt( getFromClient( ISSUED_AT ));
        const currentAccount = parseInt( this.currentAccount );
        const issuedAt = parseInt( this.issuedAt );
        console.log( 'session valid -> ' + Boolean( lastAccount === currentAccount && lastIssued === issuedAt ));
        return lastAccount === currentAccount && lastIssued === issuedAt;

    }

    public clearToken () {

        clearClient( ACCESS_TOKEN_KEY );
        clearClient( ACCESS_TOKEN_EXPIRES_KEY );
        clearClient( CURRENT_ACCOUNT );
        clearClient( ISSUED_AT );

    }

    public setValue ( key, value ) {

        this[ key ] = value;

    }

    public async getContractVersion ( contractKey ) {

        try {

            const res = await http.get( `/user/contracts?contract=${contractKey}` );
            return res.data;

        } catch ( err ) {

            console.log( err );
            unfoldError( 'errors.server_error', 10000 );

        }

    }

    public async agreeContract ( contractKey, action ) {

        try {

            await http.post( `/user/agreement`, {
                contracts: [
                    {
                        key: contractKey,
                        action: action
                    }
                ]

            });

        } catch ( err ) {

            console.log( err );
            unfoldError( 'errors.server_error', 10000 );

        }

    }
    
    public async updateCountry ( country: string ): Promise<void> {

        try {

            await http.patch( `/users/@me/profile/`, { country }, {
                baseURL: config.baseUrl + 'v1.0/',
            });

        } catch ( err ) {

            console.log( err );
            unfoldError( 'errors.server_error', 10000 );

        }
        
    }
    
    public async createEmailVerifyMFACode(): Promise<void> {

        this.mfaId = ( await createEmailMFACode( 'users.verify_email', this.email )).id;
    
    }
    
    public async verifyEmailWithMFACode( code: string ): Promise<void> {

        await http.put( '/user/email', {
            emailAddress: this.email
        }, {
            headers: {
                'x-verify-code': code,
                'x-verify-id': this.mfaId
            }
        });
        await this.getUserInfo();
    
    }

}

export default new User();
